var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "batch-btn-wrap" }, _vm._l(_vm.batchBtnArr, function (item, index) {
    return _c('div', { key: index }, [_c('permission-manager', { attrs: { "latchkey": item.permission } }, [_c('el-button', { attrs: { "plain": true, "disabled": item.batchDialogList.length === 0 }, on: { "click": function click($event) {
          return _vm.handleBatchScheduling(item.status, index);
        } } }, [_vm._v(_vm._s(item.text))])], 1)], 1);
  }), 0);
};
var staticRenderFns = [];

export { render, staticRenderFns };